import { useEffect, useState } from 'react';
import type { Customer } from '@/domain';
import { customerService } from '@/services/customerService';
import { mockStore } from '@/lib/mock-store';
import { isMockBackend } from '@/lib/supabase';

export function useCustomers(): Customer[] {
  const [rows, setRows] = useState<Customer[]>([]);

  useEffect(() => {
    let alive = true;
    customerService.list().then((data) => {
      if (alive) setRows(data);
    });
    if (isMockBackend) {
      return mockStore.subscribe(() => {
        customerService.list().then((data) => {
          if (alive) setRows(data);
        });
      });
    }
    return () => {
      alive = false;
    };
  }, []);

  return rows;
}
